var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-challenge',{attrs:{"placeholder":{
    username: _vm.$t('scope.text_331'),
  },"form-data-mapper":_vm.requestDataMapper,"form-rules":_vm.formRules,"hiddenDomainSelect":true},on:{"after-login":_vm.handleAfterLogin},scopedSlots:_vm._u([{key:"actions-right",fn:function(){return [_c('a',{staticClass:"week-link-button",on:{"click":_vm.forgetPassword}},[_vm._v(_vm._s(_vm.$t('scope.text_345')))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }